<template>
  <div class="bg">
    <div @click="goExhibition(0)">
      <img src="@/assets/img/cac.png" alt="" class="logo logo1" />
      <img src="@/assets/img/cac-text.png" alt="" class="text text1" />
    </div>
    <div @click="goExhibition(1)">
      <img src="@/assets/img/seed.png" alt="" class="logo logo2" />
      <img src="@/assets/img/seed-text.png" alt="" class="text text2" />
    </div>
    <div @click="goExhibition(2)">
      <img src="@/assets/img/Fshow.png" alt="" class="logo logo3" />
      <img src="@/assets/img/fshow-text.png" alt="" class="text text3" />
    </div>
    <div @click="goExhibition(3)">
      <img src="@/assets/img/caa.png" alt="" class="logo logo4" />
      <img src="@/assets/img/caa-text.png" alt="" class="text text4" />
    </div>
    <div @click="goExhibition(4)">
      <img src="@/assets/img/cace.png" alt="" class="logo logo5" />
      <img src="@/assets/img/cace-text.png" alt="" class="text text5" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
    data(){
        return{
            id:''
        }
    },
  methods: {
    ...mapActions({
      LinkHome: "linkTo/LinkHome",
    }),
    goExhibition(e) {
      switch (e) {
        case 0:
          this.id = "3bc3ed3d-d84e-40d6-be92-910905ba0576";
          this.LinkHome(this.id);
          break;
        case 1:
          this.id = "5fe797f0-a87e-46a6-ae72-48205eda9086";
          this.LinkHome(this.id)
          break;
        case 2:
          this.id = "63af2701-17c3-4fb1-b826-aca9228adcc3";
          this.LinkHome(this.id)
          break;
        case 3:
          this.id = "68da03a5-8127-43b0-903c-97ccb982c429";
          this.LinkHome(this.id)
          break;
        case 4:
          this.id = "33ffaaa0-6c0d-4878-b96e-d22573d3b038";
          this.LinkHome(this.id)
          break
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100vh;
  position: relative;
  background-image: url("../../assets/img/bg.jpg");
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .logo {
    width: 152px;
    height: 152px;
    cursor: pointer;
    position: absolute;
  }
  .text {
    // width: 100px;
    height: 36px;
    position: absolute;
  }
  .text1 {
    top: 526px;
    left: 443px;
    width: 100px;
  }
  .text2 {
    top: 698px;
    left: 688px;
    width: 80px;
  }
  .text3 {
    top: 526px;
    left: 915px;
    width: 92px;
  }
  .text4 {
    top: 698px;
    left: 1156px;
    width: 87px;
  }
  .text5 {
    top: 526px;
    left: 1388px;
    width: 92px;
  }
  .logo1 {
    top: 360px;
    left: 415px;
    &:hover {
      transform: scale(1.1);
    }
  }
  .logo2 {
    top: 538px;
    left: 652px;
    &:hover {
      transform: scale(1.1);
    }
  }
  .logo3 {
    top: 360px;
    left: 885px;
    &:hover {
      transform: scale(1.1);
    }
  }
  .logo4 {
    top: 538px;
    left: 1119px;
    &:hover {
      transform: scale(1.1);
    }
  }
  .logo5 {
    top: 360px;
    left: 1354px;
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>